import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { ArrowRight, MessageCircle, Target, BookOpen } from 'lucide-react';

const TOOLS = [
  {
    to: '/app/coach',
    title: 'AI Mental Performance Coach',
    desc: 'Talk through nerves, confidence, focus, and resilience with a coach that knows your role and sport.',
    icon: MessageCircle,
    cta: 'Start a session',
    tone: 'dark',
    testid: 'tile-coach',
  },
  {
    to: '/app/pregame',
    title: 'Pre-Game Prep',
    desc: 'Generate a personalized routine, visualization script, and self-talk cues for your next performance.',
    icon: Target,
    cta: 'Build your plan',
    tone: 'light',
    testid: 'tile-pregame',
  },
  {
    to: '/app/journal',
    title: 'Journal & Reflection',
    desc: 'Write what happened. Get a sports-psychology insight + prompts to deepen your growth.',
    icon: BookOpen,
    cta: 'New entry',
    tone: 'light',
    testid: 'tile-journal',
  },
];

export default function ToolsGrid() {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="tools-grid">
      {TOOLS.map((t) => {
        const Icon = t.icon;
        const dark = t.tone === 'dark';
        return (
          <Link key={t.to} to={t.to} className="group block" data-testid={t.testid}>
            <Card className={`h-full transition-all duration-200 group-hover:-translate-y-0.5 group-hover:shadow-lg ${dark ? 'bg-[#0a0d0e] border-[#0a0d0e] text-white' : 'border-border'}`}>
              <CardContent className="p-5 sm:p-6 flex flex-col h-full">
                <div className={`w-11 h-11 rounded-lg flex items-center justify-center mb-4 ${dark ? 'bg-[#004C54]/30 border border-[#004C54]/40' : 'bg-[#004C54] text-white'}`}>
                  <Icon className={`h-5 w-5 ${dark ? 'text-[#4FBCC7]' : 'text-white'}`} />
                </div>
                <h3 className={`font-heading text-lg font-bold mb-1.5 ${dark ? 'text-white' : 'text-foreground'}`}>
                  {t.title}
                </h3>
                <p className={`text-[14px] leading-relaxed mb-5 ${dark ? 'text-white/70' : 'text-foreground/70'}`}>
                  {t.desc}
                </p>
                <div className={`mt-auto inline-flex items-center gap-1.5 text-sm font-semibold ${dark ? 'text-[#4FBCC7]' : 'text-[#004C54]'}`}>
                  {t.cta}
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </div>
              </CardContent>
            </Card>
          </Link>
        );
      })}
    </div>
  );
}
